__turbopack_context__.v({
  "flag": "CountrySelector-module-scss-module__6KeWdq__flag",
});
